module.exports = {
      id: "login-usage",
      viewBox: "0 0 14.742 20.333",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#login",
      toString: function () {
        return this.url;
      }
    }